import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { MessageSquare, Send } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "@/lib/notices";
import Modal from "@/components/Modal";
import { analytics } from "@/lib/analytics";

export default function FeedbackWidget() {
  const [open, setOpen] = useState(false);
  const [category, setCategory] = useState("feature");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async () => {
    if (!message.trim()) { toast.error("Please enter a message"); return; }
    setSending(true);
    try {
      await api.post("/feedback", { category, message });
      analytics.feedbackSubmitted(category);
      toast.success("Thanks for the feedback!");
      setMessage("");
      setOpen(false);
    } catch { toast.error("Failed to send"); }
    setSending(false);
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-20 right-6 z-[60] bg-night-lift hover:bg-brand text-white rounded-sm px-4 py-3 shadow-lg transition-colors inline-flex items-center gap-2 text-sm font-medium"
        data-testid="feedback-open-btn"
      >
        <MessageSquare className="w-4 h-4" /> Feedback
      </button>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title="Help us make NextOpp better"
        description="Bugs, feature requests, or anything else."
        testid="feedback-modal"
        className="max-w-md"
        footer={
          <>
            <Button variant="outline" className="rounded-sm" onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={submit} disabled={sending} className="rounded-sm bg-brand hover:bg-brand-hover text-white" data-testid="feedback-send-btn">
              <Send className="w-4 h-4 mr-2" /> {sending ? "Sending…" : "Send"}
            </Button>
          </>
        }
      >
        <div className="space-y-4">
          <div>
            <Label className="text-sm mb-1.5 block">Category</Label>
            <Select value={category} onValueChange={setCategory}>
              <SelectTrigger className="rounded-sm" data-testid="feedback-category-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="bug">Bug report</SelectItem>
                <SelectItem value="feature">Feature request</SelectItem>
                <SelectItem value="praise">Praise</SelectItem>
                <SelectItem value="other">Other</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-sm mb-1.5 block">Message</Label>
            <Textarea rows={5} value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Tell us what’s on your mind…" className="rounded-sm" data-testid="feedback-message-input" />
          </div>
        </div>
      </Modal>
    </>
  );
}
